module.exports = __webpack_public_path__ + "static/media/1.d789d654.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/1.jpg
// module id = 579
// module chunks = 0